module.exports = "img/flags/VU.61e90ff.png";